export const nicheEndpoint = 'niches';
